export const cleanSubdomainUrl = (url: string) => {
  return (
    url
      .trim()
      .match(/[a-z0-9]*/gi)
      ?.join('') || ''
  );
};
